import React from "react";
import { useNavigate } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRealtime } from "@/context/RealtimeContext";

/** Topbar messages icon with an unread badge. Jumps to the Messages page. */
export function MessagesNavButton({ className = "" }) {
  const navigate = useNavigate();
  const { messageUnread = 0 } = useRealtime();
  return (
    <Button
      variant="ghost"
      size="icon"
      className={`relative ${className}`}
      onClick={() => navigate("/dashboard/messages")}
      title="Messages"
      aria-label="Messages"
      data-testid="nav-messages-button"
    >
      <MessageSquare className="h-5 w-5" />
      {messageUnread > 0 && (
        <span
          className="absolute -right-0.5 -top-0.5 inline-flex h-4 min-w-[16px] items-center justify-center rounded-full bg-primary px-1 text-[10px] font-[700] text-primary-foreground"
          data-testid="nav-messages-badge"
        >
          {messageUnread > 9 ? "9+" : messageUnread}
        </span>
      )}
    </Button>
  );
}
